import React from "react";
import {FlexContainer} from "./VFlex.style";
import {VFlexProps} from "./VFlex.type";

export const VFlex = ({children, ...props}: VFlexProps) => {
    return (
        <FlexContainer {...props}>
            <>{children}</>
        </FlexContainer>
    );
};
